import { Anchor, AppShell, Button, Group, Image, Menu, rem } from '@mantine/core';
import { MainContainer } from './MainContainer';
import { PageHeader } from './PageHeader';
import { useAuth0 } from '@auth0/auth0-react';
import { IconLogout } from '@tabler/icons-react';
import { clearIssuer, setSkipSessionProbe } from '@/lib/auth';

export function FallbackComponent() {
  const auth = useAuth0();
  const iconStyle = { width: rem(18), height: rem(18) };

  const handleLogout = async () => {
    setSkipSessionProbe();
    clearIssuer();
    await auth.logout({
      logoutParams: {
        returnTo: window.location.origin,
      },
    });
  };

  return (
    <AppShell header={{ height: 48 }}>
      <AppShell.Header>
        <Group h="100%" px="md" justify="space-between">
          <Group justify="start">
            <Anchor href="/">
              <Image hiddenFrom="md" src="/plm_b_full_rgb.png" w="32" h="32" alt="plamo" />
              <Image visibleFrom="md" src="/plm_a_full_rgb.png" w="100" h="32" alt="plamo" />
            </Anchor>
          </Group>
          <Group justify="end">
            <Menu shadow="md" width={200} trigger="click-hover" zIndex={1100}>
              <Menu.Target>
                <Button variant="subtle" color="gray">
                  {auth?.user?.email}
                </Button>
              </Menu.Target>
              <Menu.Dropdown>
                <Menu.Item
                  onClick={handleLogout}
                  leftSection={<IconLogout style={iconStyle} onClick={handleLogout} />}
                >
                  ログアウト
                </Menu.Item>
              </Menu.Dropdown>
            </Menu>
          </Group>
        </Group>
      </AppShell.Header>
      <AppShell.Main>
        <MainContainer>
          <PageHeader title="エラーが発生しました。" />
          <Anchor href={'/'}>
            <p>トップページに戻る</p>
          </Anchor>
        </MainContainer>
      </AppShell.Main>
    </AppShell>
  );
}
